import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import CobrancasView from './CobrancasView.vue';

// [AstraChat] Módulo de Vendas — "Cobranças" é um item de Configurações (abaixo de Segurança).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/settings/cobrancas'),
    component: SettingsWrapper,
    meta: {
      permissions: ['administrator', 'agent'],
    },
    children: [
      {
        path: '',
        name: 'cobrancas_settings_index',
        component: CobrancasView,
        meta: {
          permissions: ['administrator', 'agent'],
        },
      },
    ],
  },
];
